"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/effect-creative";

import { EffectFade } from "swiper";
import { ContentfulImage } from "@/api/contentful/types";
import { twMerge } from "tailwind-merge";
import { SwiperNavigationButton } from "../NftSliderWithHeader/SwiperNavigationButton";
import { EndemicImage } from "../Image";

export interface Props {
  images: ContentfulImage[];
  className?: string;
}

const GallerySlider = ({ images, className }: Props) => {
  return (
    <Swiper
      loop
      slidesPerView={1}
      className={twMerge("h-full !pb-10", className)}
      effect={"fade"}
      fadeEffect={{
        crossFade: true,
      }}
      pagination={{
        clickable: true,
      }}
      modules={[EffectFade]}
    >
      <div className="flex items-center justify-center absolute z-20 bottom-8 w-full">
        <SwiperNavigationButton />
        <SwiperNavigationButton isNext={true} />
      </div>

      {images.map((image: ContentfulImage) => {
        return (
          <SwiperSlide key={image.url} className="h-[400px]">
            <EndemicImage
              src={image.url}
              alt={image.fileName}
              fill
              className="mx-auto object-contain"
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default GallerySlider;
